import { useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'

/**
 * Shared hook: returns aggregate-rock vendors from Redux (if loaded),
 * otherwise falls back to a one-time fetch from /api/company/vendors.
 *
 * Returns { allVendors, suppliers } where `suppliers` is pre-filtered
 * to vendors with an active `aggregate_rock` capability.
 */
export default function useAggregateVendors () {
  const reduxVendors = useSelector((state) => state.vendors || [])
  const [fetchedVendors, setFetchedVendors] = useState(null)
  const hasFetched = useRef(false)

  useEffect(() => {
    if (reduxVendors.length === 0 && !hasFetched.current) {
      hasFetched.current = true
      axios.get('/api/company/vendors')
        .then((res) => setFetchedVendors(Array.isArray(res.data) ? res.data : (res.data.vendors || [])))
        .catch((err) => console.error('[useAggregateVendors] fallback fetch error:', err))
    }
  }, [reduxVendors.length])

  const allVendors = fetchedVendors !== null ? fetchedVendors : reduxVendors

  const suppliers = useMemo(() =>
    allVendors.filter(
      (v) => Array.isArray(v.capabilities) && v.capabilities.some(c => c.type === 'aggregate_rock' && c.isActive)
    ),
  [allVendors])

  return { allVendors, suppliers }
}
